import { Reducer } from "react";
import { ApiInteractingStatusType } from "../../../../types/common.types";
import {
  Address,
  Contacts,
  PaymentMethod,
  PersonalData,
  Subject,
} from "../../../../redux/apiSpecifications/apiSubjects";

export const AddPolicySubjectReducer: Reducer<
  AddPolicySubjectState,
  AddPolicySubjectActions
> = (state, action) => {
  // console.info(state, action);

  switch (action.type) {
    case "INIT_STATE": {
      return {
        ...state,
        addPolicySubjectData: undefined,
      };
    }

    case "SET_API_INTERACTING_STATUS": {
      return {
        ...state,
        apiInteractingStatus: action.payload,
      };
    }

    case "SET_SELECTED_SUBJECT": {
      return {
        ...state,
        addPolicySubjectData: {
          // ...state.addPolicySubjectData,
          ...action.payload,
        },
      };
    }

    case "INIT_NEW_SUBJECT": {
      return {
        ...state,
        addPolicySubjectData: {
          tenantId: action.payload.tenantId,
          personalData: {
            subjectType: "PF",
          },
        },
      };
    }

    case "CHANGE_POLICY_SUBJECT_DATA": {
      return {
        ...state,
        addPolicySubjectData: {
          ...state.addPolicySubjectData,
          [action.payload.field]: action.payload.value,
        },
      };
    }

    default:
      return state;
  }
};

export type AddPolicySubjectState = {
  addPolicySubjectData?: Subject;
  openWizard: boolean;
  apiInteractingStatus?: ApiInteractingStatusType | undefined;
};

const AddPolicySubjectDataMock: Subject = {
  // address: {
  //   country: "Italia",
  //   province: "Livorno",
  //   // fullAddress:
  //   //   "Via della Principessa & Via delle Caldanelle, 57027 San Vincenzo",
  //   city: "San Vincenzo",
  //   street:
  //     "Via della Principessa, Strada Provinciale 23 & Via delle Caldanelle",
  //   postalCode: "57027",
  //   latitude: 43.02866,
  //   longitude: 10.52797,
  // },
  // companyId: 100,
  // date: "20250118",
  // time: "12:13",
  // plateNumber: "EA887ZX",
};

export const initialAddPolicySubjectState: AddPolicySubjectState = {
  addPolicySubjectData: undefined, // {}, // AddPolicySubjectDataMock, //{ address: {} }, //
  openWizard: false,
  apiInteractingStatus: undefined,
};

type InitState = {
  type: "INIT_STATE";
};

type SetApiInteractingStatus = {
  type: "SET_API_INTERACTING_STATUS";
  payload: ApiInteractingStatusType;
};

type SetSelectedSubject = {
  type: "SET_SELECTED_SUBJECT";
  payload: Subject;
};

type InitNewSubject = {
  type: "INIT_NEW_SUBJECT";
  payload: { tenantId: number };
};

type ChangePolicySubjectData = {
  type: "CHANGE_POLICY_SUBJECT_DATA";
  payload: { value: PersonalData | Contacts | Address[] | PaymentMethod[]; field: string };
};

export type AddPolicySubjectActions =
  | InitState
  | SetApiInteractingStatus
  | SetSelectedSubject
  | InitNewSubject
  | ChangePolicySubjectData;
